/**
 * Deal API service
 */
import api from './api';

export const dealApi = {
  /** Fetch deals with optional filters */
  getDeals: (params = {}) =>
    api.get('/deals', { params }).then(r => r.data),

  /** Get deal summary (counts by level, pattern, urgency) */
  getSummary: () =>
    api.get('/deals/summary').then(r => r.data),

  /** Dismiss a deal */
  dismissDeal: (id) =>
    api.post(`/deals/${id}/dismiss`).then(r => r.data),

  /** Save a deal */
  saveDeal: (id) =>
    api.post(`/deals/${id}/save`).then(r => r.data),
};
